new Swiper('.hero-custom-slideshow', {
  loop: true,
  // autoplay: {
  //   delay: 5000,
  //   disableOnInteraction: false,
  // },
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  }
});


document.querySelectorAll('.product-list-section .product-grid-slider').forEach(function (slider) {
  var section = slider.closest('.product-list-section');
  if (!section) return;

  var nextBtn = section.querySelector('.right-arrow');
  var prevBtn = section.querySelector('.left-arrow');

  new Swiper(slider, {
    loop: false,
    slidesPerView: 4,
    spaceBetween: 12,
    watchOverflow: true,
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn
    }, 
    breakpoints: {
      0: {
        slidesPerView: 1.3,
        spaceBetween: 20
      },
      580: {
        slidesPerView: 2,
        centeredSlides: false
      },
      990: {
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 4
      }
    }
  });
});


setTimeout(function () {
  new Swiper('.product-single__related', {
    loop: false,
    slidesPerView: 4,
    spaceBetween: 12,
    watchOverflow: true,
    navigation: {
      nextEl: '.section-slider-button .right-arrow',
      prevEl: '.section-slider-button .left-arrow'
    },
    breakpoints: {
      0: {
        slidesPerView: 1.3,
        spaceBetween: 20
      },
      580: {
        slidesPerView: 2,
        centeredSlides: false
      },
      990: {
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 4
      }
    }
  });
}, 1000);


document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("submit", function (e) {
    const form = e.target.closest(".ajax-add-to-cart-form");
    if (!form) return;
    e.preventDefault();
    const formData = new FormData(form);

    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
      headers: { Accept: "application/json" }
    })
      .then((res) => res.json())
      .then((cart) => {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      })
      .catch((err) => console.error("Cart update error:", err));
  });
});

 $(document).on('click', '.cart-remove-button', function (e) {
    e.preventDefault();

    var key = $(this).data('key');

    $.ajax({
      url: '/cart/change.js',
      type: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({
        id: key,
        quantity: 0
      }),
      success: function () {
        document.dispatchEvent(new CustomEvent('cart:build'));
      }
    });
    
  });
